module.exports = __webpack_public_path__ + "static/media/5528c8bd.jpg";